import Amplify, { API, graphqlOperation } from "aws-amplify";
import Auth from "@/services/auth.service";
const authService = new Auth();

// Configure a custom GraphQL endpoint
Amplify.configure({
  API: {
    graphql_endpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
    graphql_headers: async () => ({
      Authorization: "",
    }),
  },
});

export default class GraphQLClient {
  async init () {
    const Authorization = await this.getTokenFromAuthenticationSystem();
    this.isAuthenticated = true;
    Amplify.configure({
      API: {
        graphql_headers: async () => ({
          Authorization,
        }),
      },
    });
  }
  query (query, options) {
    return API.graphql(graphqlOperation(query, options));
  }
  mutation (mutation, options) {
    return API.graphql(graphqlOperation(mutation, options));
  }
  subscription (subscription, options) {
    return API.graphql(graphqlOperation(subscription, options));
  }
  async getTokenFromAuthenticationSystem () {
    const res = await authService.currentSession();
    return res.idToken.jwtToken;
  }
}
